module.exports = __webpack_public_path__ + "media/visit_raseborg_web_hero_2019 v5_1_opt.3d68a87d.mp4";